module.exports = __webpack_public_path__ + "assets/7a0a05bcfd5ef7855ca776e61aba021c.svg";